// 导入基本公共资源
import http from './../../../base/api/public'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre
export default {
  getStationPercentagePage(params) {
    return http.requestPost(apiPre + service.ops + '/ops/stationPercentage/getStationPercentagePage',params)
  },
  insertOrUpdate(params) {
    return http.requestPost(apiPre + service.ops + '/ops/stationPercentage/insertOrUpdate',params)
  },
  getStationPercentage(params) {
    return http.requestPost(apiPre + service.ops + '/ops/stationPercentage/getStationPercentageBool',params)
  },
  delete(params) {
    return http.requestGet(apiPre + service.ops + '/ops/stationPercentage/delete/'+params)
  }



}



// WEBPACK FOOTER //
// ./src/module/dataCenter/api/stationPercentageManager.js